if (!customElements.get('sticky-atc')) {
  class ProductStickyATC extends HTMLElement {
    constructor() {
      super();

      this.button = this.querySelector('button[name="add"]');
      this.footer = document.querySelector('.footer');
      this.debouncedResize = debounce(() => this.pad(), RESIZE_DEBOUNCE_TIMER);
      this.handleBackInStockModal = this.triggerBackInStockModal.bind(this);
    }

    connectedCallback() {
      this.coreATC = document.querySelector('.product-form__buttons--main');
      this.bisEnabled = this.coreATC.dataset.bisEnabled === 'true';

      this.createTimeline();
      this.createObserver();
    }

    disconnectedCallback() {
      this.destroyObserver();
    }

    createTimeline() {
      this.timeline = gsap.timeline({ paused: true });
      this.timeline.fromTo(
        this,
        { autoAlpha: 0 },
        {
          autoAlpha: 1,
          duration: 0.5,
          ease: 'power2.inOut',
        }
      );
    }

    createObserver() {
      this.intersectionObserver = new IntersectionObserver(
        (entries, observer) => {
          if (entries[0].isIntersecting) {
            this.hide();
          } else {
            this.show();
          }
        },
        {
          rootMargin: `${this.coreATC.offsetHeight}px 0px 0px 0px`,
          threshold: 1,
        }
      );

      this.intersectionObserver.observe(this.coreATC);

      this.resizeObserver = new ResizeObserver(this.debouncedResize.bind(this));
      this.resizeObserver.observe(this);

      // TODO: Remove all of this if BIS implementation is replaced with API approach
      if (this.bisEnabled) {
        this.observeCoreMutation();
      }
    }

    observeCoreMutation() {
      this.coreMutationObserver = new MutationObserver((mutations, observer) => {
        for (const mutation of mutations) {
          if (mutation.type === 'childList') {
            for (const addedNode of mutation.addedNodes) {
              if (addedNode.classList.contains('klaviyo-bis-trigger')) {
                this.coreBackInStockTrigger = addedNode;
                this.observeVariantChange();

                if (this.coreBackInStockTrigger.style.display !== 'none') {
                  this.toggleOutOfStock(false);
                }

                observer.disconnect();
              }
            }
          }
        }
      });

      this.coreMutationObserver.observe(this.coreATC, { childList: true });
    }

    observeVariantChange() {
      this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, event => {
        const { variant } = event.data;

        this.toggleOutOfStock(variant.available);
      });
    }

    triggerBackInStockModal(e) {
      if (!this.coreBackInStockTrigger) {
        console.debug('Sticky ATC: No "Back in Stock" trigger found, aborting');
        return;
      }

      e.preventDefault();
      e.stopPropagation();
      this.coreBackInStockTrigger.click();
    }

    toggleOutOfStock(available = true) {
      this.button.removeAttribute('disabled');
      this.button.firstElementChild.textContent = available
        ? window.variantStrings.addToCart
        : this.coreBackInStockTrigger.textContent;

      if (!available) {
        this.button.addEventListener('click', this.handleBackInStockModal);
      } else {
        this.button.removeEventListener('click', this.handleBackInStockModal);
      }
    }

    destroyObserver() {
      this.intersectionObserver?.disconnect();
      this.resizeObserver?.disconnect();
      this.coreMutationObserver?.disconnect();
      this.stockObserver?.disconnect();
      this.pad(true);
      this.timeline.revert();

      if (this.variantChangeUnsubscriber) {
        this.variantChangeUnsubscriber();
        this.variantChangeUnsubscriber = null;
      }
    }

    pad(reset = false) {
      this.footer.style.paddingBottom = reset ? '' : `${this.offsetHeight}px`;
    }

    hide() {
      document.body.classList.remove('has-sticky-atc');
      this.timeline.reverse();
    }

    show() {
      document.body.classList.add('has-sticky-atc');
      this.timeline.play();
    }
  }

  customElements.define('sticky-atc', ProductStickyATC);
}
